import template from './account-information.html';
import controller from './account-information.controller';
import './account-information.scss';

let AccountInformationComponent = {
  bindings: {
    accountInfo: '<',
    userObservable: '<',
    accountProfiles: '<',
    countries: '<',
    timezones: '<',
    activeTab: '<',
    pointOfSalesCount: '<',
    spinPadCount: '<',
    pointOfSalesUnitPrice: '<',
    spinPadUnitPrice: '<',
  },
  template,
  controller
};

export default AccountInformationComponent;



// WEBPACK FOOTER //
// ./src/app/pages/account-information/account-information.component.js